<template>
    <div class="verify-otp">
      <h1>Verify OTP</h1>
      <form @submit.prevent="verifyOtp">
        <input v-model="otp" type="text" placeholder="Enter OTP" />
        <button type="submit">Verify OTP</button>
      </form>
    </div>
  </template>
  
  <script setup>
import { ref } from 'vue';
import api from '@/axios';
import { useRouter } from 'vue-router';

const otp = ref('');
const router = useRouter();

const verifyOtp = async () => {
  try {
    // Send the OTP for verification
    const mobile = localStorage.getItem('otpMobile');
    const response = await api.post('/validateotp', { otp: otp.value , mobile:mobile });

    if (response.data.success) {
      // Save the OTP verification status in localStorage
      localStorage.setItem('otpVerified', 'true');
      localStorage.setItem('token', 'true');
      localStorage.setItem('userData', response.data.success);

      // Redirect to the dashboard or the next page
      router.push('/dashboard');
    } else {
      alert('Invalid OTP');
    }
  } catch (error) {
    console.error('Error verifying OTP:', error);
  }
};
</script>

  
  <style scoped>
  /* Add your styling here */
  </style>
  